import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";
import AuthBackground from "./block1.webp";
import AuthBackgroundMobile from "./auth-background-mobile.webp";
import Logo from "./logo.webp";
import { SocialNetworks } from "./SocialNetworks";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = props => {
  const onGoLanding = () => window.location.href = 'https://slashmusic.net';
  return (
    <Container>
      <Right>
        <LogoComponent src={Logo} onClick={onGoLanding} alt="logo" height="22px" width="80px" />
        <Info>
          <Title>
            <FormattedMessage
              id="Auth.Layout.Title"
              defaultMessage="Stream your music worldwide"
            />
          </Title>
          <Subtitle>
            <FormattedMessage
              id="Auth.Layout.Subtitle"
              defaultMessage="Distribute to all major platforms starting at $4.99"
            />
          </Subtitle>
        </Info>
        <SocialNetworksBox>
          <SocialNetworks />
        </SocialNetworksBox>
      </Right>
      <Top>
        <LogoComponent src={Logo} onClick={onGoLanding} alt="logo" height="22px" width="80px" />
      </Top>
      <Left>{props.children}</Left>
    </Container>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  width: 100vw;
  height: 100vh;

  @media (max-width: 1200px) {
    flex-direction: column;
  }

  &::after {
    @media (max-width: 1200px) {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-image: url("${AuthBackgroundMobile}");
      background-position: 0;
      background-repeat: no-repeat;
      background-size: cover;
    }
  }
`;

const Top = styled.div`
  display: none;
  width: 100%;
  background: transparent;
  z-index: 1;
  padding: 30px 30px 0;
  
  @media (max-width: 1200px) {
    display: block;
  }
`;

const Right = styled.div`
  position: relative;
  flex: 1;
  z-index: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  padding: 26px 60px 40px;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background-image: url("${AuthBackground}");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
  }

  @media (max-width: 1200px) {
    display: none;
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 26px;
  color: #fff;
`;

const Title = styled.h1`
  font-family: 'Outfit';
  font-weight: 700;
  font-size: 48px;
  line-height: 33px;
  margin: 0;
`;

const Subtitle = styled.h3`
  font-weight: 400;
  font-size: 23px;
  line-height: 33px;
`;

const Left = styled.div`
  z-index: 1;
  width: 600px;
  height: 100%;
  background: #171717;

  @media (max-width: 1200px) {
    width: 100%;
    background: transparent;
  }
`;

const LogoComponent = styled.img`
  cursor: pointer;
`;

const SocialNetworksBox = styled.div`
  width:100%;
  display: flex;
  justify-content: center;
  align-items: center;
`